var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 2,
    viewBox: "0 0 32 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M124.652-484.214h-32v-2h32v2",
    transform: "translate(-92.652 486.214)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapWall);
export default __webpack_public_path__ + "static/media/agent-map-wall.5466b5dd6f52afed70b7bbdf5a0c0936.svg";
export { ForwardRef as ReactComponent };